/**
 * Liest den API-Fehlercode aus einem geworfenen Fehler.
 *
 * `apiFetch` wirft bei HTTP-Fehlern `new ApiError(message, status, data)`; der JSON-Körper der Antwort
 * liegt also in `err.details` (z. B. `{ ok: false, error: { code: 'unknown_asl_category' } }`).
 * Ältere Formen (`err.code`, `err.error.code`, `err.response.error.code`) bleiben lesbar.
 * Liefert `undefined`, wenn kein String-Code vorhanden ist (Netzwerkfehler, Text-Fehler, fremde Objekte).
 */
export function getApiErrorCode(err) {
  const candidates = [err?.details?.error, err?.error, err?.response?.error, err?.details, err];
  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object' && typeof candidate.code === 'string' && candidate.code) {
      return candidate.code;
    }
  }
  return undefined;
}
